import { render, staticRenderFns } from "./vdialog.vue?vue&type=template&id=36da52a5&scoped=true"
import script from "./vdialog.vue?vue&type=script&lang=js"
export * from "./vdialog.vue?vue&type=script&lang=js"
import style0 from "./vdialog.vue?vue&type=style&index=0&id=36da52a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da52a5",
  null
  
)

export default component.exports